<template>
  <div class="holidays">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Holidays {{ currentYear }}</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Holidays</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_holiday"
                  ><i class="fa fa-plus"></i> Add Holiday</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Holiday Date</th>
                      <th>Day</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in holidays"
                      :key="item.id"
                      :class="{
                        'holiday-completed': item.status == 1,
                        'holiday-upcoming': item.status == 0
                      }"
                    >
                      <td>{{ item.title }}</td>
                      <td>{{ item.holiday }}</td>
                      <td>{{ item.day }}</td>
                      <td class="text-center">
                        <div
                          class="dropdown dropdown-action"
                          v-if="item.status == 0"
                        >
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              href="#"
                              @click="setHoliday(item)"
                              data-toggle="modal"
                              data-target="#edit_holiday"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              href="#"
                              @click="setHoliday(item)"
                              data-toggle="modal"
                              data-target="#delete_holiday"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- /Page Content -->

        <!-- Add Holiday Modal -->
        <div class="modal custom-modal fade" id="add_holiday" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Holiday</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearHoliday"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="postHoliday">
                  <div class="form-group">
                    <label
                      >Holiday Name <span class="text-danger">*</span></label
                    >
                    <input class="form-control" type="text" v-model="title" />
                  </div>
                  <div class="form-group">
                    <label
                      >Holiday Date <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      type="date"
                      v-model="holidayDate"
                    />
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Holiday Modal -->

        <!-- Edit Holiday Modal -->
        <div class="modal custom-modal fade" id="edit_holiday" role="dialog">
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Holiday</h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearHoliday"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <form @submit.prevent="putHoliday">
                  <div class="form-group">
                    <label
                      >Holiday Name <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      value="New Year"
                      type="text"
                      v-model="holiday.title"
                    />
                  </div>
                  <div class="form-group">
                    <label
                      >Holiday Date <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      v-model="holiday.holiday"
                      type="date"
                    />
                  </div>
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">Save</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Holiday Modal -->

        <!-- Delete Holiday Modal -->
        <div class="modal custom-modal fade" id="delete_holiday" role="dialog">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Holiday</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        @click="removeHoliday"
                        class="btn btn-primary continue-btn"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        href="javascript:void(0);"
                        data-dismiss="modal"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Holiday Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { organizationService } from "@/services/organizationService";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      holidayDate: null,
      title: null,
      holiday: {},
      holidays: [],
      loading: false,
      message: null,
      error: null
    };
  },
  methods: {
    setHoliday(item) {
      this.holiday = item;
    },
    clearHoliday() {
      (this.title = null),
        (this.holidayDate = null),
        (this.message = null),
        (this.error = null);
    },
    postHoliday() {
      if (!this.title & !this.holidayDate) {
        alert("Title and Holiday Date is required");
        return;
      }

      this.loading = true;
      organizationService.postHoliday(this.title, this.holidayDate).then(
        id => {
          this.getHolidays();
          this.message = "Holiday added successfully";
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    putHoliday() {
      if (!this.holiday.title & !this.holiday.holidayDate) {
        alert("Title and Holiday Date is required");
        return;
      }
      this.loading = true;
      organizationService.putHoliday(this.holiday).then(
        model => {
          this.holidays = model;
          this.message = "Holiday updated successfully";
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    removeHoliday() {
      this.loading = true;
      organizationService.removeHoliday(this.holiday.id).then(
        model => {
          this.getHolidays();
          this.message = "Holiday deleted successfully";
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    getHolidays() {
      organizationService.getHolidays().then(r => {
        this.holidays = r;
        console.log(r);
      });
    }
  },
  mounted() {
    this.getHolidays();
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "holidays"
};
</script>



// WEBPACK FOOTER //
// src/components/miscs/holidays.vue